
import Faq from 'components/ckan/Faq'

export default function FaqPage(){
  return(
  <Faq />
  )
}

export async function getStaticProps() {
  return {
    props: {
      meta: {
        title: "CKAN FAQ",
        description: "Helpful answers to your most common questions about CKAN, such a features, usability, portability and integration.",
      },
    },
  };
};